const LEGACY_THEME_TO_CSS_VAR_NAMES: Map<string, string> = new Map<
  string,
  string
>([
  ['color_48', '--wst-button-color-fill-primary'],
  ['color_49', '--wst-button-color-border-primary'],
  ['color_50', '--wst-button-color-text-primary'],
  ['color_51', '--wst-button-color-fill-primary-hover'],
  ['color_52', '--wst-button-color-border-primary-hover'],
  ['color_53', '--wst-button-color-text-primary-hover'],
  ['color_54', '--wst-button-color-fill-primary-disabled'],
  ['color_55', '--wst-button-color-border-primary-disabled'],
  ['color_56', '--wst-button-color-text-primary-disabled'],
  ['color_57', '--wst-button-color-fill-secondary'],
  ['color_58', '--wst-button-color-border-secondary'],
  ['color_59', '--wst-button-color-text-secondary'],
  ['color_60', '--wst-button-color-fill-secondary-hover'],
  ['color_61', '--wst-button-color-border-secondary-hover'],
  ['color_62', '--wst-button-color-text-secondary-hover'],
  ['color_63', '--wst-button-color-fill-secondary-disabled'],
  ['color_64', '--wst-button-color-border-secondary-disabled'],
  ['color_65', '--wst-button-color-text-secondary-disabled'],
  ['color_36', '--wst-color-fill-base-1'],
  ['color_37', '--wst-color-fill-base-2'],
  ['color_38', '--wst-color-fill-base-shade-1'],
  ['color_39', '--wst-color-fill-base-shade-2'],
  ['color_40', '--wst-color-fill-base-shade-3'],
  ['color_41', '--wst-color-fill-accent-1'],
  ['color_42', '--wst-color-fill-accent-2'],
  ['color_43', '--wst-color-fill-accent-3'],
  ['color_44', '--wst-color-fill-accent-4'],
  ['color_11', '--wst-color-fill-background-primary'],
  ['color_12', '--wst-color-fill-background-secondary'],
  ['color_15', '--wst-color-text-primary'],
  ['color_14', '--wst-color-text-secondary'],
  ['color_18', '--wst-color-action'],
  ['color_39', '--wst-color-disabled'],
  ['color_45', '--wst-color-title'],
  ['color_46', '--wst-color-subtitle'],
  ['color_47', '--wst-color-line'],
  ['font_1', '--wst-font-style-h1'],
  ['font_2', '--wst-font-style-h2'],
  ['font_3', '--wst-font-style-h3'],
  ['font_4', '--wst-font-style-h4'],
  ['font_5', '--wst-font-style-h5'],
  ['font_6', '--wst-font-style-h6'],
  ['font_7', '--wst-font-style-body-large'],
  ['font_8', '--wst-font-style-body-medium'],
  ['font_9', '--wst-font-style-body-small'],
  ['font_10', '--wst-font-style-body-x-small'],
]);

function invertMap(originalMap: Map<string, string>): Map<string, string> {
  const invertedMap = new Map();

  for (const [key, value] of originalMap.entries()) {
    invertedMap.set(value, key);
  }

  return invertedMap;
}

const CSS_VAR_NAMES_TO_LEGACY_THEME: Map<string, string> = invertMap(
  LEGACY_THEME_TO_CSS_VAR_NAMES,
);

export const themeToCssVarName = (theme?: string): string | undefined =>
  theme ? LEGACY_THEME_TO_CSS_VAR_NAMES.get(theme) : undefined;

export const cssVarNameToTheme = (cssVar?: string): string | undefined =>
  cssVar ? CSS_VAR_NAMES_TO_LEGACY_THEME.get(cssVar) : undefined;
